const PREFIXED_ABSOLUTE_MEDIA = /\/wp-content\/uploads\/(https?:\/\/\S+)/i;

/**
 * If WordPress joined `upload_dir.baseurl` onto an already-absolute URL
 * (`…/wp-content/uploads/https://res.cloudinary.com/…`), return the inner URL.
 * Otherwise return the input unchanged.
 */
export function unwrapPrefixedAbsoluteMediaUrl(url: string): string {
  const match = url.match(PREFIXED_ABSOLUTE_MEDIA);
  return match?.[1] ?? url;
}
